export default "__VITE_ASSET__X8dM6mU7Vtv6fNQ4dYMp7A__"